import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const HolidayList = Loadable(
  lazy(() => import("features/holiday/components/List"))
);
const HolidayPage = Loadable(
  lazy(() => import("features/holiday/components/Page"))
);


const routes = {
  path: "holiday",
  children: [
    { path: "", element: <HolidayList /> },
    { path: "add", element: <HolidayPage /> },
    { path: "edit/:holidayID?", element: <HolidayPage /> }
  ],
};

export default routes;
